export default __webpack_public_path__ + "sgp/assets/loginChoiceBgImage-d1864d2088.jpg";